declare namespace $ {

	type $shm_hitalama_map_fontsize__font_size_shm_hitalama_map_widget_float_autoview_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_autoview['font_size'] >
		,
		ReturnType< $shm_hitalama_map_fontsize['font_size'] >
	>
	type $shm_hitalama_map_widget_view_autoview__code_widget_shm_hitalama_map_widget_float_autoview_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_autoview['code_widget'] >
		,
		ReturnType< $shm_hitalama_map_widget_view_autoview['code_widget'] >
	>
	type $shm_hitalama_map_widget_view_autoview__Map_page_shm_hitalama_map_widget_float_autoview_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_autoview['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_view_autoview['Map_page'] >
	>
	export class $shm_hitalama_map_widget_float_autoview extends $shm_hitalama_map_widget_float {
		font_size( next?: number ): number
		Font_size_tool( ): $shm_hitalama_map_fontsize
		autoview_plain_tools( ): readonly(any)[]
		code_widget( ): $shm_hitalama_map_widget
		content( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_autoview['View'] >['sub'] >
		result( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_autoview['View'] >['result'] >
		tools_custom( ): readonly(any)[]
		View( ): $shm_hitalama_map_widget_view_autoview
	}
	
}

//# sourceMappingURL=autoview.view.tree.d.ts.map